import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CollapsibleItem from '../components/CollapsibleItem';
import {taxEstimatorQuestions, sectionIds, taxSteps} from '../constants';
import SliderInput from '../components/SliderInput';
import { updateParentsTaxInfo } from '../actions/parents';
import { updateSection } from '../actions/ui';

const TaxEstimator = () => {

  const dispatch = useDispatch();
  const parents = useSelector((state) => state.parents.parents);

  const updateTaxInfo = (index,type,value) =>{
    dispatch(updateParentsTaxInfo(index,type,value));
    dispatch(updateSection(sectionIds.TAX_ESTIMATOR));
  }

  const getTaxIndex = (type,rate) => {
    return taxSteps[type].indexOf(rate)
  }


  return (
    <CollapsibleItem
    id={sectionIds.TAX_ESTIMATOR}
    >
      {parents.map((item,index) => (
        <>
          <SliderInput
            label={taxEstimatorQuestions(item.name).FEDERAL}
            max={taxSteps.FEDERAL.length-1}
            tooltipLabel={(n)=>{return (`${taxSteps.FEDERAL[n]}%`)}}
            initialValue={1}
            value={getTaxIndex('FEDERAL',item.taxes.federalRate)}
            onUpdateValue={(v)=>updateTaxInfo(index,'federalRate',taxSteps.FEDERAL[v])}
          />
          <SliderInput
            label={taxEstimatorQuestions(item.name).STATE}
            max={taxSteps.STATE.length-1}
            tooltipLabel={(n)=>{return (`${taxSteps.STATE[n]}%`)}}
            initialValue={5}
            value={getTaxIndex('STATE',item.taxes.stateRate)}
            onUpdateValue={(v)=>updateTaxInfo(index,'stateRate',taxSteps.STATE[v])}

          />
        </>
      ))}
  </CollapsibleItem>
  )
}

export default TaxEstimator;

